const HOST = window.location.origin;

export default Object.freeze({
  HOST,
});
